export const SET_ADS_CAMPAIGNS = 'setAdsCampaigns';
export const CLEAR_CAMPAIGN_INFO = 'clearCampaignInfo';
export const SET_ADS_LIST = 'setAdsList';
export const UPDATE_CURRENT_CAMPAIGN = 'updateCurrentCampaign';
export const UPDATE_CURRENT_CAMPAIGN_STATUS = 'updateCurrentCampaignStatus';
export const ADD_PRODUCT_TO_ADS_LIST = 'addProductToAdsList';
export const REMOVE_PRODUCT_FROM_ADS_LIST = 'removeProductFromAdsList';
